/**
 * The idle lock held back (./kunciDiam's `tertahan`): the session has been idle past the ten
 * minutes, but unsaved work keeps the device unlocked. What is secret on screen closes then,
 * while the work stays: every password field shown with "Tampilkan" is masked again
 * (components/akun/SandiInput), and every initial password typed for someone else (Buat akun,
 * Buatkan akun SATU, Tambah orang's account step, Paroki baru's admin, Atur ulang) empties
 * itself, saying nothing about it. Said once per idle period; ./kunciDiamTab says it for the
 * tab. Listeners subscribe through components/akun/useDiamTertahan.
 *
 * No React here and relative imports only: ./kunciDiamTab wires it from the launch path.
 */

type Pendengar = () => void

const pendengar = new Set<Pendengar>()

/** Tells every listener on screen that the idle lock is held back now. */
export function umumkanDiamTertahan(): void {
  for (const dengar of [...pendengar]) dengar()
}

/** Listens until the returned function is called. */
export function dengarDiamTertahan(dengar: Pendengar): () => void {
  pendengar.add(dengar)
  return () => {
    pendengar.delete(dengar)
  }
}
